import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import MobileApp from './MobileApp';
import registerServiceWorker from './registerServiceWorker';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import Access from './components/Auth/Access';
import ErrorBundary from './components/ErrorBoundary';

import 'bootstrap/dist/css/bootstrap.css';
// Authorization initialization
const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.handleRedirectPromise();

// Create browser history to use in the Redux store
const baseUrl = '';
// const baseUrl = document
//   .getElementsByTagName('base')[0]
//   .getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

////
// reference
//https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
let hasTouchScreen = false;
  if(window.screen.availWidth <= 1024 || (window.screen.availHeight > window.screen.availWidth && window.screen.availHeight <= 1024)){
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    //@ts-ignore
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = matchMedia?.('(pointer:coarse)');
    if (mQ?.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      //@ts-ignore
      const UA = navigator.userAgent;
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }
}
////

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={10}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <ErrorBundary>
          <Access>
            <ConnectedRouter history={history}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                {hasTouchScreen ? <MobileApp /> : <App />}
              </ThemeProvider>
            </ConnectedRouter>
          </Access>
        </ErrorBundary>
      </SnackbarProvider>
    </Provider>
  </MsalProvider>,
  document.getElementById('root')
);

registerServiceWorker();
